export { default, B2CLoginSocialButtons } from './B2CLoginSocialButtons';
